import React from "react";
import classNames from "classnames";
import FaIcon from "./FaIcon";
import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-light-svg-icons";

interface Props {
  text: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
}

export default function (props: Props) {
  return (
    <div className={classNames("w-full flex flex-row content-center min-h-8 gap-2 [&_p]:m-0 [&_p]:p-0", props.className)}>
      {!props.disabled && props.checked ? (
        <FaIcon color={"#31BB3F"} icon={faCircleCheck} size={"lg"} />
      ) : (
        <FaIcon icon={faCircleXmark} size={"lg"} />
      )}
      <p>{props.text}</p>
    </div>
  );
}
